import React from 'react'
import { Button, Typography } from '@paintscout/ui'
import { useTrialOverDashboard } from '../useTrialOverDashboard'
import StatCards from '../../shared/StatCards'
import { useTrialOverDashboardMobileLayoutStyles } from './useTrialOverDashboardMobileLayoutStyles'

export default function TrialOverDashboardMobile() {
  const classes = useTrialOverDashboardMobileLayoutStyles()
  const { isAdmin, handleSelectPlan } = useTrialOverDashboard()

  return (
    <div className={classes.root}>
      <div className={classes.leftSection}>
        <Typography className={classes.heading}>
          <span className={classes.headingFirstLine}>
            <span className={classes.headingHighlight}>Your PaintScout trial is over,</span>
          </span>
          <span className={classes.headingSecondLine}>but it doesn&lsquo;t have to end here.</span>
        </Typography>
        {isAdmin && (
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={handleSelectPlan}
            className={classes.button}
          >
            Select Plan
          </Button>
        )}
      </div>
      <div className={classes.whiteBackground}>
        <div className={classes.rightSection}>
          <StatCards classes={classes} />
        </div>
      </div>
    </div>
  )
}
